import { render, staticRenderFns } from "./zxkt.vue?vue&type=template&id=2a32a1de&scoped=true&"
import script from "./zxkt.vue?vue&type=script&lang=js&"
export * from "./zxkt.vue?vue&type=script&lang=js&"
import style0 from "./zxkt.vue?vue&type=style&index=0&id=2a32a1de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32a1de",
  null
  
)

export default component.exports